import React, {FC} from 'react'
import {Button, Icon, Stack, Typography} from '@mdsol/onex-design'
import ReactJson from 'react-json-view'

interface DiagnosticDetailsPanelProps {
  item: any
  onClose: () => void
}

const DiagnosticDetailsPanel: FC<DiagnosticDetailsPanelProps> = ({item, onClose}) => {
  return (
    <div className='row-details-panel'>
      <div className='header onex-data-grid-control'>
        <Typography variant='h4'>Diagnostic Details</Typography>
        <Button
          dataTestId='close-details-icon'
          onClick={onClose}
          variant='secondary'
          buttonStyle='ghost'
          buttonType='icon'
        >
          <Icon>close</Icon>
        </Button>
      </div>

      <div className='body onex-data-grid-control'>
        <ReactJson
          src={item}
          theme='rjv-default'
          iconStyle='circle'
          indentWidth={2}
          collapseStringsAfterLength={16}
          quotesOnKeys={false}
        />
      </div>

      <div className='footer onex-data-grid-control'>
        <Stack direction='horizontal' gap={2}>
          <Button dataTestId='close-details-button' onClick={onClose} size='md' variant='secondary'>
            Close
          </Button>
        </Stack>
      </div>
    </div>
  )
}

export default DiagnosticDetailsPanel
